import FilesUpload from "components/EvtKit/file-upload/FilesUpload"
import FileUploadButton from "components/EvtKit/file-upload/FileUploadButton"
import IconImageUploadWithSubtitle from "components/EvtKit/icons/IconImageUploadWithSubtitle"
import React, { memo, useEffect, useMemo, useState } from "react"
import styled from "styled-components"

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
`

const ImageUploadIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${(props) => props.theme.palette.white};
  border-radius: 12px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
`

const StyledImage = styled.img`
  object-fit: contain;
`

interface BannerCardContentProps {
  bannerImageFile: File | undefined
  bannerImageUrl: string
  handleBannerFileChange: (files: File[]) => void
}

const BannerCardContent: React.FC<BannerCardContentProps> = (props: BannerCardContentProps) => {
  const { bannerImageFile, bannerImageUrl, handleBannerFileChange } = props

  const [bannerImagePreview, setBannerImagePreview] = useState<string>("")

  const previewUrl = useMemo(() => {
    return bannerImagePreview || bannerImageUrl || ""
  }, [bannerImagePreview, bannerImageUrl])

  const showImage = useMemo(() => {
    return !!previewUrl || !!bannerImageUrl
  }, [previewUrl, bannerImageUrl])

  useEffect(() => {
    let bannerImageObjectUrl: string | null = null

    if (bannerImageFile) {
      bannerImageObjectUrl = URL.createObjectURL(bannerImageFile)
      setBannerImagePreview(bannerImageObjectUrl)
    } else {
      setBannerImagePreview("")
    }

    // Clean up URL when changing file or unmounting component
    return () => {
      if (bannerImageObjectUrl) {
        URL.revokeObjectURL(bannerImageObjectUrl)
      }
    }
  }, [bannerImageFile])

  return (
    <ImageContainer>
      {!showImage && (
        <FilesUpload acceptFormats={["image/png", "image/webp"]} onFilesChange={handleBannerFileChange}>
          <FileUploadButton>
            <ImageUploadIconContainer>
              <IconImageUploadWithSubtitle />
            </ImageUploadIconContainer>
          </FileUploadButton>
        </FilesUpload>
      )}
      {showImage && <StyledImage src={previewUrl} alt="banner image" />}
    </ImageContainer>
  )
}

export default memo(BannerCardContent)
